const { arrayToHashmap } = require('../../utils/helpers');
const config = require('../config.js');
const pools = require('../pools');
const { poolsData, ...restChainABIsExports } = require(`./abis-${config.blockchainId}.js`);
const sharedABIs = require('./abis-shared.js');

const { poolIds, poolIdsWithAliases } = pools;

const poolsDataIds = Array.from(Object.keys(poolsData));
const poolsWithoutABIData = poolIds.filter((id) => !poolsDataIds.includes(id));

if (poolsWithoutABIData.length) {
    throw new Error(`All pools need to have a corresponding data object under \`constants/abis/\`. Pools not found: ${poolsWithoutABIData.join(', ')}`);
}

const abiData = arrayToHashmap(poolIdsWithAliases.map((id) => {
    const pool = pools.find((pool) => pool.id === id || pool.idAlias === id);
    return [id, poolsData[pool.id]];
}));

const mergedABIs = { ...sharedABIs, ...restChainABIsExports, ...abiData, contractAbis: abiData };

module.exports = mergedABIs;
